<app-loader *ngIf="mostrarLoader"></app-loader>
<div class="container-fluid p-0">
    <div class="row">
        <div class="col-xl-6" [ngStyle]="{'background-image': 'url(assets/images/login/logo_login.png)',
                                        'background-size': 'cover',
                                        'background-position': 'center center',
                                        'display': 'block'}">
            <img class="bg-img-cover bg-center d-none" src="assets/images/login/logo_login.png" alt="looginpage">
        </div>
        <div class="col-xl-6 p-0">
            <div class="login-card">
                <div>
                    <div>
                        <a class="logo" routerLink='/'>
                            <img class="img-fluid for-light" src="assets/images/login/logo1.png" width="200"
                                alt="looginpage">
                            <img class="img-fluid for-dark" src="assets/images/login/logo1.png" width="200"
                                alt="looginpage">
                        </a>
                    </div>
                    <div class="login-main">
                        <form class="theme-form needs-validation" [class.was-validated]="!loginForm.valid" novalidate=""
                            [formGroup]="loginForm">
                            <h4>Crea tu cuenta</h4>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label">Nombre</label>
                                        <input class="form-control" type="text" required=""
                                            placeholder="Ingresá tu nombre" formControlName="nombre">
                                        <div class="invalid-tooltip"
                                            *ngIf="loginForm.controls.nombre.touched && loginForm.controls.nombre.errors?.required">
                                            El Nombre es
                                            necesario.</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label">Apellido</label>
                                        <input class="form-control" type="text" required=""
                                            placeholder="Ingresá tu apellido" formControlName="apellido">
                                        <div class="invalid-tooltip"
                                            *ngIf="loginForm.controls.apellido.touched && loginForm.controls.apellido.errors?.required">
                                            El Apellido es
                                            necesario.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Nro Documento</label>
                                <input class="form-control" type="text" [maxlength]="8" required=""
                                    placeholder="Ingresá tu nro. de documento" formControlName="nrodoc"
                                    (input)="onInputChange($event)">
                                <div class="invalid-tooltip"
                                    *ngIf="loginForm.controls.nrodoc.touched && loginForm.controls.nrodoc.errors?.required">
                                    El Nro. de documento es
                                    necesario.</div>
                                <div class="invalid-tooltip" *ngIf="loginForm.controls.nrodoc.errors?.pattern">
                                    El Nro. de documento solo puede contener números.
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Email</label>
                                <input class="form-control" type="email" required="" placeholder="Ingresá tu email"
                                    formControlName="email">
                                <div class="invalid-tooltip"
                                    *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.required">
                                    El Email es
                                    necesario.</div>
                                <div class="invalid-tooltip"
                                    *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.email">
                                    Este email es
                                    invalido.</div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Username</label>
                                <input class="form-control" type="text" required="" placeholder="Ingresá tu username"
                                    formControlName="username">
                                <div class="invalid-tooltip"
                                    *ngIf="loginForm.controls.username.touched && loginForm.controls.username.errors?.required">
                                    El Nro. de documento es
                                    necesario.</div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Contraseña</label>
                                <input class="form-control" [type]="show ? 'text' : 'password'" name="login[password]"
                                    required="" placeholder="*********" formControlName="password">
                                <div class="invalid-tooltip"
                                    *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required">
                                    La
                                    Contraseña es necesaria.</div>
                                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span>
                                </div>
                                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span>
                                </div>
                            </div>
                            <div class="form-group mb-0" *ngIf="mostrar">
                                <hr class="text-muted mt-2">
                                <button class="btn btn-primary btn-pill d-block w-100" type="button"
                                    [disabled]="!loginForm.valid" (click)="register()">Registrate</button>
                            </div>
                            <p class="mt-4 mb-0">Ya eres paciente?<a class="ms-2" [routerLink]="'/login'">Inicia
                                    sesión</a></p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>